var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Instagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 480",
    width: "480px",
    height: "480px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface25507755"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 480,
    height: 480,
    style: {
      fill: "rgb(7.058824%,7.058824%,7.058824%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 160 60 C 104.78125 60 60 104.78125 60 160 L 60 320 C 60 375.21875 104.78125 420 160 420 L 320 420 C 375.21875 420 420 375.21875 420 320 L 420 160 C 420 104.78125 375.21875 60 320 60 Z M 360 100 C 371.039062 100 380 108.960938 380 120 C 380 131.039062 371.039062 140 360 140 C 348.960938 140 340 131.039062 340 120 C 340 108.960938 348.960938 100 360 100 Z M 240 140 C 295.21875 140 340 184.78125 340 240 C 340 295.21875 295.21875 340 240 340 C 184.78125 340 140 295.21875 140 240 C 140 184.78125 184.78125 140 240 140 Z M 240 180 C 206.863281 180 180 206.863281 180 240 C 180 273.136719 206.863281 300 240 300 C 273.136719 300 300 273.136719 300 240 C 300 206.863281 273.136719 180 240 180 Z M 240 180 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram);
export default __webpack_public_path__ + "static/media/icons8-instagram.e2d53743c13d538f2c78c1e9282e9127.svg";
export { ForwardRef as ReactComponent };